import { render, staticRenderFns } from "./SendMessageForm.vue?vue&type=template&id=6720bda2&scoped=true&"
import script from "./SendMessageForm.vue?vue&type=script&lang=js&"
export * from "./SendMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageForm.vue?vue&type=style&index=0&id=6720bda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720bda2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextField,VTextarea})
